import { PublishSubject } from '../../../lib/subjects.esm.js';

class AlertApiForwarder {
  subject = new PublishSubject();
  post(alert) {
    this.subject.next(alert);
  }
  alert$() {
    return this.subject;
  }
}

export { AlertApiForwarder };
//# sourceMappingURL=AlertApiForwarder.esm.js.map
